//import { render } from "react-dom";
import {
  BrowserRouter,
  Routes,
  Route,
  HashRouter
} from "react-router-dom";

import './App.css';

//COMPONENTES PAGES
import PublicPonto from "./components/pages/PublicPonto";
import Login from './components/pages/Login'

import AdminPonto from "./components/pages/AdminPonto";
import Carrinho from './components/pages/Carrinho'
import Painel from "./components/pages/AdminPainel";
import AdminProduto from "./components/pages/AdminProduto";
import AdminFrete from "./components/pages/AdminFrete";
import AdminCliente from "./components/pages/AdminCliente"
import AdminClienteFornecedor from "./components/pages/AdminClienteFornecedor"
import PageIndex from "./components/pages/PageIndex"
import AdminProdutoCategoria from "./components/pages/AdminProdutoCategoria";
import AdminDadosEmpresa from "./components/pages/AdminDadosEmpresa"
import AdminOrcamentos from "./components/pages/AdminOrcamentos"
import AdminVendaRapida from "./components/pages/AdminVendaRapida"
import AdminEstoqueProduro from "./components/pages/AdminEstoquProduto";
import AdminLeads from "./components/pages/AdminLead"
import AdminLog from "./components/pages/AdminLog";
import TeancyAuth from "./components/midllers/TenancyAuth";
import AdminImagem from "./components/pages/AdminImagem"
import AdminEntregador from "./components/pages/AdminEntregador"
import AdminCustoEmpresa from"./components/pages/AdminCustosEmpresa"
import axios from 'axios';
import PrivateRouter from "./components/midllers/PrivateRouter";
import AdminPix from "./components/pages/AdminPix";
import AdminCaixa from "./components/pages/AdminCaixa";
import Leadpageebook01 from './components/pages/Leadpageebook01'
import LeadpageAfiliados from './components/pages/LeadpageAfiliados'

import Catalogo from "./components/partils/Catalogo";
import AdminLojaVirtual from "./components/pages/AdminLojaVirtual"
import AdminWhatsApp from"./components/pages/AdminWhatsApp"

import AreaDoCliente from "./components/pages/AreaDoCliente";
import { useEffect, useState } from "react";
import Pedido from "./components/pages/Pedido";
import AdminFeature from "./components/pages/AdminFeature";
import AdminFinanceiroTenancy from "./components/pages/AdminFinanceiroTenancy";
import AdminAssistenteInteligente from "./components/pages/AdminAssistenteInteligente";
import AdminVendaRealizada from "./components/pages/AdminVendasRealizada";
import AdminAgenda from "./components/pages/AdminAgenda";
import AdminFuncionario from './components/pages/AdminClienteFuncionario';
import AdminVendaProdutoServico from'./components/pages/AdminVendaProdutoServico'

//COMPONENTES PARTLS
//import Menu from "./components/partils/Menu";

//sessionStorage.getItem('keyItemNameg')
const tlocal = localStorage.getItem('keyItemNameg')
const tenancylocal = localStorage.getItem('ClienteTenancy')

axios.defaults.baseURL = "https://autometricas.com.br"
//axios.defaults.baseURL = "http://localhost:3002"
if (tlocal) {
  axios.defaults.headers.common['token'] = tlocal;
}
if (tenancylocal) {
  axios.defaults.headers.common['idtenancy'] = tenancylocal;
  //axios.defaults.headers.common['tenancyId'] = tenancylocal;
  // de idtenancy para idtenancy
}
axios.defaults.headers.common['device'] = navigator.userAgent;


//axios.defaults.withCredentials = true;
function App() {
  const [usernivel, setUsernivel] = useState(1);

  useEffect(() => {
        const nivel = localStorage.getItem('usernivel');
        nivel&&setUsernivel(nivel);
        //console.log("Verificando usernivel:", nivel);
}, []);


  return (
    <HashRouter>

    <Routes>
      <Route path="/" element={<PageIndex />} />

      
      <Route path="/login" element={<Login />} />
      <Route path="/ebookdigitalcomofaturarmaisem2026" element={<Leadpageebook01/>} />
      <Route path="/programadeafiliados" element={<LeadpageAfiliados/>} />
      
      <Route path="/home" element={<Catalogo />} />
      <Route path="/carrinho" element={<Carrinho />} />
      <Route path="/pedido" element={<Pedido/>} />
      
      <Route path="/loja/:id" element={<TeancyAuth />} />
      <Route path="/ponto/:id/:funcionario/:tenancy" element={<PublicPonto/>} />
      
      <Route path="/areadocliente/orcamentoAuth0/:id/:ch" element={<AreaDoCliente/>}/>

      <Route element={<PrivateRouter/>}>
        <Route path="/adminentregador" element={<AdminEntregador />} />
        <Route path="/adminponto" element={<AdminPonto />} />
        <Route path="/adminassistenteinteligente" element={<AdminAssistenteInteligente />} />
        
       
          <Route path="/painel" element={  usernivel >= 19 ?<Painel />:<div className="w100 h100 column center fs09em fb">Carregando...</div>} />

          <Route path="/admincustoempresa" element={<AdminCustoEmpresa />} />
          <Route path="/adminlog" element={<AdminLog />} />
          <Route path="/adminvendarealizada" element={<AdminVendaRealizada />} />
          <Route path="/adminpix" element={<AdminPix />} />
          <Route path="/admincaixa" element={<AdminCaixa />} />
          <Route path="/admialojavirtual" element={<AdminLojaVirtual />} />
          
        
        <Route path="/adminproduto" element={<AdminProduto />} />
       
        <Route path="/admincliente" element={<AdminCliente />} />
        
        <Route path="/adminclientefornecedor" element={<AdminClienteFornecedor />} />
        <Route path="/admincategoriaproduto" element={<AdminProdutoCategoria />} />
        <Route path="/admindadosempresa" element={<AdminDadosEmpresa />} />
        <Route path="/adminpedido" element={<AdminOrcamentos />} />
        <Route path="/adminvendarapidaEdtar/:param1" element={<AdminVendaRapida />} />
        <Route path="/adminvendarapida" element={<AdminVendaRapida />} />
        <Route path="/adminvendaprodutoservico" element={<AdminVendaProdutoServico />} />
        <Route path="/adminlead" element={<AdminLeads />} />
        <Route path="/admiagenda" element={<AdminAgenda />} />
        <Route path="/adminprodutoestoque" element={<AdminEstoqueProduro />} />
        <Route path="/adminimagen" element={<AdminImagem />} />
        <Route path="/adminfrete" element={<AdminFrete />} />
        <Route path="/adminwhatsapp" element={<AdminWhatsApp />} />
        <Route path="/adminfeature" element={<AdminFeature />} />
        <Route path="/adminfinanceirotenancy" element={<AdminFinanceiroTenancy />} />
        <Route path="/adminclientefuncionario" element={<AdminFuncionario />} />
        
      </Route>
    </Routes>
   </HashRouter>
  );
}

export default App;
